import { useNavigate } from 'react-router-dom'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'

import Button from '../../../common/components/Button'
import Layout from '../../../common/components/Layout'
import styles from './Confirmation.module.css'

const ConfirmationPage = () => {
  const navigate = useNavigate()
  const handleSignIn = () => {
    navigate('/')
  }

  return (
    <Layout backgroundColor="accentColor">
      <div className={styles.confirmationContainer}>
        <div>
          <div className={styles.imageWrapper}>
            <CheckCircleOutlineRoundedIcon sx={{ width: 260, height: 260 }} />
          </div>
          <h3 className={styles.title}>Welcome to Menty.</h3>
          <p className={styles.confirmationText}>
            Awesome, you signed up! Let's get started right now.
          </p>
        </div>
        <div className={styles.buttonWrapper}>
          <Button title="Sign In" onClick={handleSignIn} />
        </div>
      </div>
    </Layout>
  )
}

export default ConfirmationPage
